import { Helmet } from "react-helmet-async";
import { useI18n } from "../../i18n/context.tsx";
import { getCanonical, getHreflangs } from "../../utils/seo.ts";

interface SeoHeadProps {
  title: string;
  description: string;
  /** The "bare" path without locale prefix, e.g. "/basketball/classic" */
  path: string;
  ogImage?: string;
  jsonLd?: object;
}

export function SeoHead({ title, description, path, ogImage, jsonLd }: SeoHeadProps) {
  const { locale } = useI18n();
  const canonical = getCanonical(path, locale);
  const hreflangs = getHreflangs(path);

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonical} />
      <link rel="alternate" hrefLang="en" href={hreflangs.en} />
      <link rel="alternate" hrefLang="ja" href={hreflangs.ja} />
      <link rel="alternate" hrefLang="x-default" href={hreflangs.en} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:locale" content={locale === "ja" ? "ja_JP" : "en_US"} />
      <meta property="og:type" content="website" />
      {ogImage && <meta property="og:image" content={ogImage} />}
      <meta name="twitter:card" content="summary_large_image" />
      {jsonLd && <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>}
    </Helmet>
  );
}
